import * as React from "react";
import confetti from "canvas-confetti";

import { Button } from "@/components/shadcn/button.tsx";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/shadcn/dialog.tsx";
import { useTranslation } from "react-i18next";
import { constants } from "@/constants";
import { alertError } from "@/utils/utils.ts";
import { Input } from "@/components/shadcn/input.tsx";
import { useState } from "react";
import { useQueryClient } from "react-query";
import { queryKey } from "@/store/queryKeys.ts";
import { BalanceCashbackAlert } from "@/pages/profile/ProfilePageMostAI.tsx";
import {Icon} from "@/components/Icon.tsx";

const runConfetti = () => {
  confetti({
    particleCount: 200,
    spread: 150,
    origin: { y: 0.6 },
  });
};

interface ApplyPromocodeModalProps {
  open: boolean;
  onOpenChange: (opened: boolean) => void;
}

export const ApplyPromocodeModal = ({
  open,
  onOpenChange,
}: ApplyPromocodeModalProps) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const [promocode, setPromocode] = useState("");
  const [balanceChange, setBalanceChange] = useState<any>(null);

  async function promoCodeApply(code: string) {
    try {
      let url = `${constants.url.API_PREFIX}promocode/apply`;
      const response = await fetch(url, {
        method: "POST", // Метод запроса
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          code: code,
        }),
      });

      let respData = await response.json();
      if (respData.error_code) {
        alertError(t(respData.error_code));
        return;
      } else if (!respData.error) {
        setBalanceChange(respData);
        runConfetti();
      }

      queryClient.invalidateQueries(queryKey.balance);
    } catch (e) {
      alertError(t("alerts.default_error_message"));
    }
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(opened: boolean) => {
        onOpenChange(opened);
        if (!opened) {
          setBalanceChange(null);
        }
      }}
    >
      <DialogTrigger asChild>
        <Button variant="outline" className="[&_svg]:size-6">
          <Icon icon="mdi:coupon-outline" />
          {t("billing.enter_promo_code")}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Промокод</DialogTitle>
          <DialogDescription></DialogDescription>
        </DialogHeader>

        {!balanceChange && (
          <>
            <Input
              type="promocode"
              onChange={(e: any) => {
                setPromocode(e.target.value);
              }}
              placeholder="Введите код промокода"
            />

            <Button
              variant="default"
              onClick={() => {
                promoCodeApply(promocode);
              }}
            >
              Применить
            </Button>
          </>
        )}

        {balanceChange && <BalanceCashbackAlert balanceData={balanceChange} />}

        {balanceChange && balanceChange.bonuses && (
          <div className="text-center">
            <h5>🎉&nbsp;Начислено бонусов&nbsp;🎉</h5>
            <div className="text-5xl py-4 flex items-center gap-4 justify-center">
              {balanceChange.bonuses}
            </div>
          </div>
        )}

        {balanceChange && balanceChange.balance_rub && (
          <div className="text-center">
            <h5>🎉&nbsp;Начислен баланс&nbsp;🎉</h5>
            <div className="text-5xl py-4 flex items-center gap-4 justify-center">
              {balanceChange.balance_rub}&nbsp;₽
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
